import {useRef, useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {fetchPosition} from 'web/redux/actions/PositionActions';

import enumList from 'web/utils/enumList';

export const usePositionModalControl = () => {
  const dispatch = useDispatch();
  const positionModalRef = useRef(null);
  const [positionModalMode, setPositionModalMode] = useState(
    enumList.modalMode.new,
  );

  useEffect(() => {
    if (positionModalRef.current) {
      positionModalRef.current = new bootstrap.Modal(positionModalRef.current);
    }
  }, []);

  const togglePositionModal = (show, mode, positionId) => {
    if (show) {
      if (positionId) dispatch(fetchPosition(positionId));
      setPositionModalMode(mode);
      positionModalRef.current.show();
    } else {
      positionModalRef.current.hide();
    }
  };

  return {
    positionModalMode,
    positionModalRef,
    togglePositionModal,
  };
};
